import { AppThunk } from '~/reducers';
import { MappedOptionFacetView, TaxonomyNodeView } from '~/types/responseTypes';
import { VendorTaxonomyNodeId } from '~/types/types';

import ApiService from '../util/apiService';
import Logger from '../util/logger';
import {
  REQUESTING_TAXONOMY,
  RECEIVED_TAXONOMY,
  REQUESTING_FACETS,
  RECEIVED_FACETS,
  RequestingTaxonomyAction,
  ReceivedTaxonomyAction,
  RequestingFacetsAction,
  ReceivedFacetsAction,
} from './types/taxonomyActionTypes';

export const requestingTaxonomy = (): RequestingTaxonomyAction => {
  return {
    type: REQUESTING_TAXONOMY,
  };
};

export const receivedTaxonomy = (response: TaxonomyNodeView[]): ReceivedTaxonomyAction => {
  return {
    type: RECEIVED_TAXONOMY,
    payload: response,
  };
};

export const getTaxonomy = (): AppThunk<Promise<void>> => {
  return (dispatch) => {
    dispatch(requestingTaxonomy());
    return ApiService.get('/web-marketplace-api/v1/taxonomy', { cacheKey: ['taxonomy-facets'] })
      .then((json: TaxonomyNodeView[]) => {
        dispatch(receivedTaxonomy(json));
      })
      .catch((error) => {
        // TODO: Error handling should be improved
        // Ideally this would throw an error and the client would decide how to handle it
        Logger.error(error.message, error);
      });
  };
};

export const requestingFacets = (key?: string): RequestingFacetsAction => {
  return {
    type: REQUESTING_FACETS,
    ...(key && { key }),
  };
};

export const receivedFacets = (
  response: MappedOptionFacetView[],
  key?: string
): ReceivedFacetsAction => {
  return {
    type: RECEIVED_FACETS,
    payload: response,
    ...(key && { key }),
  };
};

export const getFacets = (
  taxonomyNodeId: VendorTaxonomyNodeId,
  key: string
): AppThunk<Promise<void>> => {
  return (dispatch) => {
    dispatch(requestingFacets(key));
    const query = key ? `?key=${key}` : '';
    return ApiService.get(`/web-marketplace-api/v1/taxonomy/facets/${taxonomyNodeId}${query}`)
      .then((json: MappedOptionFacetView[]) => {
        dispatch(receivedFacets(json, key));
      })
      .catch((error) => {
        // TODO: Error handling should be improved
        // Ideally this would throw an error and the client would decide how to handle it
        Logger.error(error.message, error);
      });
  };
};
